<h1 mat-dialog-title class="dialog-header" [ngClass]="{ 'compact-header': useCompactStyle }">
	{{ this.dialogHeader }}
</h1>
@if (showDevider) {
	<hr class="divider" [ngClass]="{ 'compact-divider': useCompactStyle }" style="margin: 0px 24px" />
}
<div mat-dialog-content [ngClass]="{ 'compact-content': useCompactStyle, 'default-content': !useCompactStyle }">
	{{ this.dialogContent }}
</div>
@if (this.dialogSecondaryHeader) {
	<div
		[ngClass]="{ 'compact-content': useCompactStyle, 'default-content': !useCompactStyle, 'secondary-header': true }"
	>
		{{ this.dialogSecondaryHeader }}
	</div>
}
@if (this.dialogSecondaryContent) {
	<div [ngClass]="{ 'compact-content': useCompactStyle, 'default-content': !useCompactStyle }">
		{{ this.dialogSecondaryContent }}
	</div>
}
@for (item of this.dialogListedItemContent; track item) {
	<div [ngClass]="{ 'compact-content': useCompactStyle, 'default-content': !useCompactStyle }">
		{{ item }}
	</div>
}
<div mat-dialog-actions>
	<!-- Older style buttons with mat-button -->
	@if (!!dialogSecondaryButtonText && !useSmallButtons) {
		<button
			mat-button
			(click)="onSecondaryButtonClicked()"
			class="secondary-button"
			data-automation-id="cancel-confirmation-secondary-button"
		>
			{{ this.dialogSecondaryButtonText }}
		</button>
	}
	@if (!!dialogPrimaryButtonText && !useSmallButtons) {
		<button
			mat-button
			(click)="onPrimaryButtonClicked()"
			class="primary-button"
			data-automation-id="cancel-confirmation-primary-button"
		>
			{{ this.dialogPrimaryButtonText }}
		</button>
	}

	<!-- (Newer style) small buttons without mat-button -->
	@if (!!dialogSecondaryButtonText && useSmallButtons) {
		<button
			(click)="onSecondaryButtonClicked()"
			class="secondary-small-button"
			data-automation-id="cancel-confirmation-secondary-button"
		>
			{{ this.dialogSecondaryButtonText }}
		</button>
	}
	@if (!!dialogPrimaryButtonText && useSmallButtons) {
		<button
			(click)="onPrimaryButtonClicked()"
			[ngClass]="useWarningStyle ? 'warning-small-button' : 'primary-small-button'"
			class="right-button"
			data-automation-id="cancel-confirmation-primary-button"
		>
			{{ this.dialogPrimaryButtonText }}
		</button>
	}
</div>
